/** Correct released risk hints for live UI without changing accepted contract terms. */
export function currentContractDescription(description: string): string {
  return description
    .replace("PvE-пограничье:", "Поле обломков:")
    .replace(
      "При гибели теряется четверть груза;",
      "При любой гибели весь груз выпадает в контейнерах;",
    )
    .replace(
      "При гибели выпадает половина обычного груза и вся контрабанда.",
      "При любой гибели весь груз выпадает в контейнерах.",
    );
}
